import axios from "axios";
import { getCurrentClientConfig } from "config/clientConfig";

const defaultCoreHeader = process.env.REACT_APP_CORE_HEADER || "core_header";
const currentClientConfig = getCurrentClientConfig();

const axiosClient = axios.create({
  baseURL: currentClientConfig.apiBaseUrl,
  headers: { "Content-Type": "application/json" },
  timeout: 60000,
});

// REQUEST INTERCEPTOR - Add token to every request
axiosClient.interceptors.request.use(
  (config) => {
    config.headers = config.headers || {};

    const tenantId = currentClientConfig.tenantId;
    if (tenantId && !config.headers["x-tenant-id"]) {
      config.headers["x-tenant-id"] = tenantId;
    }

    if (!config.skipCustomHeader && defaultCoreHeader && !config.headers["x-custom-header"]) {
      config.headers["x-custom-header"] = defaultCoreHeader;
    }

    const token = !config.skipAdminAuth && sessionStorage.getItem("adminToken");
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// RESPONSE INTERCEPTOR - Handle 401 unauthorized errors
axiosClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (
      error.response &&
      error.response.status === 401 &&
      !error.config?.skipAdminAuth
    ) {
      sessionStorage.removeItem("adminToken");
      sessionStorage.removeItem("adminUser");
    }
    return Promise.reject(error);
  }
);

export default axiosClient;
